import rootStore from '@/store/root'

export default (props) => {
  return {
    computed: {
      fontStyles () {
        return props.reduce((styles, prop) => {
          return {
            ...styles,
            [prop]: !this[prop] ? {} : {
              fontFamily: `"${this[prop]}"`
            }
          }
        }, {})
      }
    },
    methods: {
      async addFont (fontFamily) {
        rootStore.dispatch('registerFont', { fontFamily, path: this.path })
      },
      removeFont (fontFamily) {
        rootStore.dispatch('unregisterFont', { fontFamily, path: this.path })
      }
    },
    mounted () {
      for (const prop of props) {
        // check if prop exists
        if (this[prop] === undefined) {
          throw new Error(`Missing the "${prop}" prop.`)
        } else if (this[prop]) {
          // add font
          this.addFont(this[prop])
        }
        // set up a watcher callback for the prop
        this.$watch(prop, (newFont, oldFont) => {
          if (oldFont) {
            this.removeFont(oldFont)
          }
          if (newFont) {
            this.addFont(newFont)
          }
        })
      }
    },
    beforeDestroy () {
      for (const prop of props) {
        if (this[prop] && this[prop]) {
          this.removeFont(this[prop])
        }
      }
    }
  }
}
